import { TimeSeriesApi } from 'api/';
import { getApiActionCreator } from 'helpers/actionHelper';
import { apiCallStatus } from 'helpers/constants';
import { commonActionTypes } from './constants';
import { actionTypes } from './OperationalParametersV2/SingleChartView/Trend/constants';


const trendKpiActionV2 = getApiActionCreator(commonActionTypes.GET_ASSET_TREND_KPIS_V2);
const trendKpiActionSelecton = getApiActionCreator(actionTypes.GET_TREND_KPI_LIST_SELECTION);


export const getTrendKPIsForAssetV2 = (asset) => {
    return (dispatch, getState) => {
        const trendCheck = getState().operationalParameters?.charts?.single?.trend;
        if (trendCheck?.length && trendCheck[0]?.kpiList?.length) {
            dispatch(trendKpiActionSelecton(apiCallStatus.SUCCESS, []));
        }
        dispatch(trendKpiActionV2(apiCallStatus.LOADING));
        return TimeSeriesApi.getMeasurementTypes(asset?.id)
            .then((data) => {
                dispatch(trendKpiActionV2(apiCallStatus.SUCCESS, data));
                return data;
            })
            .catch((err) => {
                dispatch(trendKpiActionV2(apiCallStatus.ERROR, null, err));
            });
    };
};
